import type React from 'react';

function EncoreIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 195.24 220"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      <title>Encore Icon</title>
      <defs>
        <clipPath id="clippath">
          <rect width="195.24" height="220" fill="none" />
        </clipPath>
      </defs>

      <g id="Layer_1-2" data-name="Layer 1">
        <path d="M195.08,170.07v49.17H.76V70.88c30.78-6.63,61.35-15.18,91.07-25.65C127.32,32.83,161.73,18.08,195.08,.76V55.49c-28.22,13.68-57.5,25.65-87.22,36.13-33.56,11.76-67.98,21.16-102.82,28.43v.43c64.35-5.99,127.62-16.46,190.04-31v50.24c-62.42,14.11-125.91,24.16-190.04,29.93v.43H195.08Z" />
      </g>
    </svg>
  );
}

export default EncoreIcon;
